<template lang="pug">
  .login-view
    .login-view-container
      .h-100.row.align-items-center
        login.col-sm-12.col-md-4
</template>

<script>
import Login from '../components/auth/Login'

export default {
  components: {
    Login
  }
}
</script>

<style lang="scss" scoped>
.login-view {
  padding: 1rem;
  height: 100%;
  background-color:#1C3FAA;
  &-container {
    height: 100%;
  }
}
.login {
  margin: auto;
}
</style>
